import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import './styles.css';
class WindowIconTitle extends Component {
	render() {
		const { icon, title, className } = this.props;
		return (
			<div className={`${className || ''} window-icon-title`}>
				<Icon icon={icon} />
				<span className="regular-font">{title}</span>
			</div>
		);
	}
}
WindowIconTitle.propTypes = {
	icon: PropTypes.string,
	title: PropTypes.string,
	className: PropTypes.string
};

export default WindowIconTitle;
